<template>
  <input :id="faq.question" class="faq__check hidden" type="checkbox" @change="handleToggleChange" />
  <label class="faq__question relative flex cursor-pointer py-4 pl-3 pr-9" data-testid="faq-item" :for="faq.question">
    <p class="question__text overflow-auto break-words pl-5">{{ faq.question }}</p>
  </label>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="faq__answer break-words px-2" v-html="faq.answer" />
</template>

<script lang="ts" setup>
import { useFaqTracking } from '@/wabunka-src/features/FAQ/composables/useFaqTracking';
import type { EnFaqViewModel } from '@/wabunka-src/features/FAQ/models/enFaq';

interface Props {
  faq: EnFaqViewModel;
}

const props = defineProps<Props>();
const { trackFaqOpen } = useFaqTracking();

const handleToggleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.checked) {
    trackFaqOpen(props.faq);
  }
};
</script>

<style lang="scss" scoped>
.faq__answer {
  height: 0;
  opacity: 0;
  padding: 0 12px 0;
  visibility: hidden;
  padding-left: 2rem;
}

.faq__check:checked + .faq__question + .faq__answer {
  height: unset;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 25px;
  visibility: visible;
  padding-left: 2rem;
  :deep(a) {
    text-decoration: underline;
  }
}

label:after {
  content: '';
  display: block;
  width: 8px;
  height: 8px;
  border-top: black 1px solid;
  border-right: black 1px solid;
  transform: rotate(45deg);
  position: absolute;
  left: 10px;
  top: 12%;
  bottom: 15%;
  margin: auto;
}

input[type='checkbox']:checked + label:after {
  content: '';
  display: block;
  width: 8px;
  height: 8px;
  border-top: black 1px solid;
  border-right: black 1px solid;
  transform: rotate(135deg);
  position: absolute;
  left: 11px;
  top: -5%;
  bottom: 0;
  margin: auto;
}
</style>
